import { NewButton } from "components/common";
import React from "react";

/**
 * @param {Object} props
 * @param {Function} props.onClick
 * @param {String} props.error
 * @param {Boolean} props.loading
 * @param {String} props.title
 * @returns
 */
export const VerificationContinueButton = (props) => {
  const { onClick, error, loading, title = "Continue" } = props;
  return (
    <>
      <NewButton
        colorVariant="secondary-light"
        onClick={onClick}
        disabled={loading}
        className="px-4 py-2 w-full mt-6 md:w-auto"
      >
        <p>{loading ? "Loading..." : title }</p>
      </NewButton>
      <p className="mt-1 text-red-500">{error}</p>
    </>
  );
};
